function OnboardingTemplateGraphic({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="absolute inset-x-0 bottom-0 top-[15%] flex items-end justify-center pointer-events-none select-none">
      <img src={src} alt={alt} className="max-h-full max-w-[90%] w-auto h-auto object-contain object-bottom" />
    </div>
  );
}

export default OnboardingTemplateGraphic;
